import { TodayButton } from '@devexpress/dx-react-scheduler-material-ui';
import { useIsSmallScreen } from '../../../../../../../../Hooks/useFullscreenView';

export const TodayButtonComponent = (props: TodayButton.ButtonProps) => {
  const isSmallScreen = useIsSmallScreen();
  return (
    <TodayButton.Button
      {...props}
      style={{
        minWidth: isSmallScreen ? '40px' : undefined,
        fontSize: isSmallScreen ? 'xx-small' : undefined,
      }}
    ></TodayButton.Button>
  );
};
